import * as React from "react"
import { useNavigate, useParams } from "react-router-dom"
import { authApi } from "@/api/auth"
import { ApiError } from "@/api/client"
import { Alert, AlertDescription } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { useAuth } from "@/hooks/use-auth"

export function AcceptInvitePage() {
  const { token = "" } = useParams()
  const { state, refresh } = useAuth()
  const nav = useNavigate()
  const [error, setError] = React.useState<string | null>(null)
  const [pending, setPending] = React.useState(false)

  if (state === "anonymous") {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Daveti kabul et</CardTitle>
          <CardDescription>Devam etmek için önce giriş yap.</CardDescription>
        </CardHeader>
        <CardContent>
          <Button
            onClick={() =>
              nav(`/login?redirect=${encodeURIComponent(`/accept-invite/${token}`)}`)
            }
          >
            Giriş yap
          </Button>
        </CardContent>
      </Card>
    )
  }

  async function accept() {
    setError(null)
    setPending(true)
    try {
      await authApi.acceptInvite(token)
      await refresh()
      nav("/dashboard", { replace: true })
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Davet kabul edilemedi.")
    } finally {
      setPending(false)
    }
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Davete katıl</CardTitle>
        <CardDescription>Bu daveti kabul ederek organizasyona katılıyorsun.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {error && (
          <Alert variant="destructive">
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        )}
        <Button onClick={accept} disabled={pending} className="w-full">
          {pending ? "İşleniyor…" : "Daveti kabul et"}
        </Button>
      </CardContent>
    </Card>
  )
}
